import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Button from 'components/Common/Button'
import axios from 'axios'
import { useLocation } from 'react-router-dom'
import APIRoutes from '../../api/routes'
import { Loader } from '@progress/kendo-react-indicators'
import { Box, Typography, Link } from '@mui/material'
import './index.css'
import { DISABLED_BUTTON, PRIMARY_BUTTON } from 'themes/theme'
import { DatePicker } from '@progress/kendo-react-dateinputs'
import moment from 'moment'

const sx = {
  header: {
    width: '160px',
    wordBreak: 'break-word',
  },
}

const ThanksComponent = () => {
  return (
    <div className="container" style={{ textAlign: 'center', color: '#25245f' }}>
      <div className="row justify-content-md-left">
        <div>
          <img
            src="https://dashboard.app.markaaz.com/static/media/markaaz_logo_blue.043fce4d.png"
            height={40}
            alt="logo"
          />
        </div>
        <div style={{ marginTop: '30px' }}>
          <h1>
            <b>Thank you !</b>
          </h1>
        </div>
      </div>
      <div className="row justify-content-md-center text-center">
        <div className="col p-5 m-5">
          <h3>
            We will alert the business owner that you have provided the requested information. You may close this
            window.
          </h3>
        </div>
      </div>
    </div>
  )
}

const BeneficialForm = () => {
  const url = process.env['REACT_APP_VAULT_API_URL']
  const [requiredFields, setRequiredFields] = useState({
    middleName: false,
    ssnField: false,
  })
  const [formDetails, updateForm] = useState(false)
  const [userDetails, updateUserDetails] = useState()
  const [validDetails, setValidDetails] = useState(false)

  const { search } = useLocation()
  const maskedTextBox = useRef(null)
  const SSNNumber = useRef(null)
  const form = useRef(null)

  const getQueryStringParams = query => {
    return query
      ? (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce((params, param) => {
          let [key, value] = param.split('=')
          params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : ''
          return params
        }, {})
      : {}
  }

  const searchParams = useMemo(() => getQueryStringParams(search), [search])
  const headers = useMemo(
    () => ({
      Authorization: `Bearer ${searchParams.auth_id}`,
    }),
    [searchParams.auth_id],
  )

  const fetchBusinessDetails = useCallback(() => {
    !userDetails &&
      axios
        .get(`${url}${APIRoutes.vaultRetrieveBOInfo}`, {
          params: {
            reference_id: searchParams.reference,
          },
          headers: headers,
        })
        .then(res => {
          updateUserDetails(res.data)
          axios
            .get('https://geolocation-db.com/json/')
            .then(IPRes => {
              updateForm({
                ...formDetails,
                ipAddress: IPRes.data.IPv4,
                dob: moment().format('YYYY-MM-DD'),
              })
            })
            .catch(err => console.error(err))
        })
        .catch(err => console.error('Err', err))
  }, [url, searchParams.reference, headers, formDetails, userDetails])

  useEffect(() => {
    fetchBusinessDetails()
  }, [fetchBusinessDetails])

  const [isTermsAgreed, updateTermsStatus] = useState(false)
  const [formSubmitSucess, updateFormStatus] = useState(false)
  const [errors, updateError] = useState({})
  const [showError, setErrorAlert] = useState(false)
  const [dobValue, setDOBValue] = React.useState()
  const [loading, setLoading] = useState(false)

  const changeDate = event => {
    setDOBValue(event.value)
    updateForm({
      ...formDetails,
      dob: moment(event.value).format('YYYY-MM-DD'),
    })
  }

  const handleKeyPress = e => {
    var regex = new RegExp('^[0-9]+$')
    var key = String.fromCharCode(!e.charCode ? e.which : e.charCode)
    if (!regex.test(key)) {
      e.preventDefault()
      return false
    }
  }

  const handleBlur = e => {
    const { name, value } = e.target
    if (value) {
      let error = false
      if (name === 'dob') {
        if (!moment(value).isValid()) error = 'Invalid date'
        if (moment(value).isAfter(moment())) error = 'Invalid date'
      }
      updateError({ ...errors, [name]: error })
    } else {
      updateError({ ...errors, [name]: true })
    }
  }

  function onFormChange(e) {
    setValidDetails(form.current.checkValidity())
  }

  const updateInput = e => {
    updateForm({ ...formDetails, [e.target.name]: e.target.value })
  }

  const handleSubmit = e => {
    e.preventDefault()
    setLoading(true)
    axios
      .post(
        `${url}${APIRoutes[userDetails?.ownerType === 'I' ? 'vaultPostBoIndividualInfo' : 'vaultPostBoInfo']}`,
        {
          ...formDetails,
          t_vault_id: userDetails.vaultId,
          reference_id: searchParams.reference,
        },
        {
          headers: headers,
        },
      )
      .then(res => {
        updateFormStatus(true)
        updateUserDetails(res.data)
        setErrorAlert(false)
      })
      .catch(err => setErrorAlert(true))
  }

  const isIndividual = userDetails?.ownerType === 'I'
  const maskSSN = (e, focus) => {
    var res = e.target.value, //grabs the value
      len = res.length, //grabs the length
      stars = len > 0 ? (len > 1 ? (len > 2 ? (len > 3 ? (len > 4 ? 'XXX-XX-' : 'XXX-X') : 'XXX-') : 'XX') : 'X') : '', //this provides the masking and formatting
      result = stars + res.substring(5) //this is the result
    updateForm({ ...formDetails, [e.target.name]: e.target.value })
    if (focus) {
      SSNNumber.current.value = e.target.value
    } else {
      SSNNumber.current.value = result
    }
  }
  const ErrorInfo = props => {
    const { error = false } = props
    return <div className="errorInfo">{error || 'This field is required'}</div>
  }
  return (
    <Box className="customCard">
      <Box>
        {formSubmitSucess ? (
          <ThanksComponent />
        ) : (
          <>
            <Box
              display={'flex'}
              alignItems="center"
              flexDirection="column"
              gridGap="35px"
              className="px-2"
              marginBottom="60px"
            >
              <img
                className="mt-4"
                src="https://dashboard.app.markaaz.com/static/media/markaaz_logo_blue.043fce4d.png"
                height={40}
                alt="logo"
              />
              <Typography color="#25245F" variant="h4">
                Beneficial Ownership Information
              </Typography>
            </Box>
            {userDetails ? (
              <>
                <Box
                  display="flex"
                  height="100px"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ background: '#fff' }}
                >
                  <Box>
                    {userDetails?.claimed && (
                      <Box width="700px" display="flex" justifyContent="space-between">
                        {/* <img src="https://app.markaaz.com/static/media/markaaz_logo_blue.043fce4d.png" height={40} alt="logo" /> */}
                        <Box sx={sx.header}>
                          <Typography variant="overline1" color="#0A78CD">
                            BUSINESS NAME
                          </Typography>
                          <address style={{ maxWidth: '300px' }} className="font-weight-bold mb-0">
                            <Typography variant="body1" color="#25245F">
                              {userDetails?.details?.company}
                            </Typography>
                          </address>
                        </Box>
                        <Box sx={sx.header}>
                          <Typography variant="overline1" color="#0A78CD">
                            ADDRESS
                          </Typography>
                          <address style={{ maxWidth: '300px' }} className="font-weight-bold mb-0">
                            <Typography variant="body1" color="#25245F">
                              {userDetails?.details?.details?.addressStreet}
                            </Typography>
                          </address>
                        </Box>
                        <Box sx={sx.header}>
                          <Typography variant="overline1" color="#0A78CD">
                            CITY
                          </Typography>
                          <Typography variant="body1" color="#25245F">
                            {userDetails?.details?.details?.addressCity}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography variant="overline1" color="#0A78CD">
                            STATE
                          </Typography>
                          <Typography variant="body1" color="#25245F">
                            {userDetails?.details?.state}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography variant="overline1" color="#0A78CD">
                            ZIP
                          </Typography>
                          <Typography variant="body1" color="#25245F">
                            {userDetails?.details?.zip}
                          </Typography>
                        </Box>
                      </Box>
                    )}
                    {!userDetails?.claimed && (
                      <div>
                        <h4 className="text-center color-secondary">
                          This business has not been claimed through the Directory Services.
                        </h4>
                      </div>
                    )}
                  </Box>
                </Box>
                <Box className="my-4 authForm container" sx={{ maxWidth: '700px !important' }}>
                  <Box marginY="70px" textAlign="center" fontSize="14px" color="#66668F">
                    The below information is encrypted while being transmitted and in storage. Access is restricted to
                    yourself and any organizations which your business should instruct Markaaz to share it with.
                  </Box>
                  <form onSubmit={e => handleSubmit(e)} ref={form} onChange={onFormChange}>
                    <div className="form-row form-group row">
                      <div
                        className={`form-group 
                          ${errors[isIndividual ? 'first_name' : 'business_name'] ? 'invalid' : ''} ${
                          isIndividual ? 'col-md-6' : 'col-md-8'
                        } col-sm-12 my-2`}
                      >
                        <label className="required" htmlFor={isIndividual ? 'first_name' : 'business_name'}>
                          {isIndividual ? 'First Name' : 'Name of business/corporation/or other entity'}
                        </label>
                        <input
                          type="text"
                          name={isIndividual ? 'first_name' : 'business_name'}
                          className="form-control form-control-lg"
                          id={isIndividual ? 'first_name' : 'business_name'}
                          onChange={e => updateInput(e)}
                          onBlur={handleBlur}
                          required
                        ></input>
                        <ErrorInfo />
                      </div>
                      {isIndividual && (
                        <div className={`form-group col-md-6 col-sm-12 my-2 ${errors.last_name ? 'invalid' : ''}`}>
                          <label className="required" htmlFor="last_name">
                            Last Name
                          </label>
                          <input
                            type="text"
                            name="last_name"
                            onChange={e => updateInput(e)}
                            className="form-control form-control-lg"
                            id="last_name"
                            required
                            onBlur={handleBlur}
                          ></input>
                          <ErrorInfo />
                        </div>
                      )}

                      {isIndividual && (
                        <div className={`form-group col-md-4 col-sm-12 my-2 ${errors.middleName ? 'invalid' : ''}`}>
                          <label className={`${!requiredFields.middleName ? 'required' : ''}`} htmlFor="middle_name">
                            Middle Initial
                          </label>
                          <input
                            type="text"
                            name="middleName"
                            onChange={e => updateInput(e)}
                            className="form-control form-control-lg"
                            id="middle_name"
                            disabled={requiredFields.middleName}
                            required={!requiredFields.middleName}
                            onBlur={handleBlur}
                          ></input>
                          <ErrorInfo />
                        </div>
                      )}
                      {isIndividual && (
                        <div className={`form-group col-md-4 col-sm-12 my-2 ${errors.dob ? 'invalid' : ''}`}>
                          <label className="required" htmlFor="dob">
                            Date of Birth
                          </label>
                          <DatePicker
                            name="dob"
                            formatPlaceholder="formatPattern"
                            format={'MM/dd/yyyy'}
                            defaultValue={dobValue}
                            max={new Date()}
                            onChange={changeDate}
                            onBlur={handleBlur}
                          />
                          <ErrorInfo error={errors?.dob} />
                        </div>
                      )}
                      <div
                        className={`form-group col-md-4 col-sm-12 my-2 ${errors.ownership_percentage ? 'invalid' : ''}`}
                      >
                        <label className="required" htmlFor="ownership_percentage">
                          % Ownership in this business
                        </label>
                        <input
                          type="number"
                          name="ownership_percentage"
                          onChange={e => updateInput(e)}
                          className="form-control form-control-lg"
                          id="ownership_percentage"
                          required
                          onBlur={handleBlur}
                          onWheel={e => e.target.blur()}
                          onKeyDown={e => {
                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') return e.preventDefault()
                          }}
                        ></input>
                        <ErrorInfo />
                      </div>
                    </div>
                    {isIndividual && (
                      <Box className="col-sm-12 mb-2" sx={{ marginTop: '-20px' }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="large"
                              sx={{
                                color: '#BDBDCE',
                                '&.Mui-checked': {
                                  color: '#0A78CD',
                                },
                              }}
                              onChange={e => {
                                const { checked } = e.target
                                if (!checked && !formDetails.middleName) {
                                  updateError({ ...errors, middleName: true })
                                } else {
                                  updateError({ ...errors, middleName: false })
                                  updateForm({ ...formDetails, middleName: '' })
                                }
                                setRequiredFields({
                                  ...requiredFields,
                                  middleName: !requiredFields.middleName,
                                })

                                setTimeout(onFormChange, 300)
                              }}
                              defaultChecked={false}
                            />
                          }
                          label={
                            <Box color="#66668F" fontSize="12px">
                              I do not have a middle name
                            </Box>
                          }
                        />
                      </Box>
                    )}
                    <div className="form-row form-group row">
                      <div
                        className={`form-group col-sm-12 my-2 ${isIndividual ? 'col-md-8' : 'col-md-12'} ${
                          errors.address ? 'invalid' : ''
                        }`}
                      >
                        <label className="required" htmlFor="address">
                          {isIndividual ? 'Address' : 'Business Address'}
                        </label>
                        <input
                          type="text"
                          name="address"
                          // style={{width: isIndividual ? '440px' : '670px'}}
                          className="form-control form-control-lg"
                          onChange={e => updateInput(e)}
                          id="address"
                          onBlur={handleBlur}
                          required
                        ></input>
                        <ErrorInfo />
                      </div>

                      {isIndividual && (
                        <div className={`form-group col-md-4 col-sm-12 my-2 ${errors.country ? 'invalid' : ''}`}>
                          <label className="required" htmlFor="country">
                            Country
                          </label>
                          <input
                            type="text"
                            name="country"
                            className="form-control form-control-lg"
                            onChange={e => updateInput(e)}
                            id="country"
                            onBlur={handleBlur}
                            required
                          ></input>
                          <ErrorInfo />
                        </div>
                      )}

                      <div className={`form-group col-md-4 col-sm-12 my-2 ${errors.city ? 'invalid' : ''}`}>
                        <label className="required" htmlFor="city">
                          City
                        </label>
                        <input
                          type="text"
                          name="city"
                          className="form-control form-control-lg"
                          onChange={e => updateInput(e)}
                          id="city"
                          onBlur={handleBlur}
                          required
                        ></input>
                        <ErrorInfo />
                      </div>
                      <div className={`form-group col-md-4 col-sm-12 my-2 ${errors.state ? 'invalid' : ''}`}>
                        <label className="required" htmlFor="state">
                          State
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          id="state"
                          name="state"
                          onChange={e => updateInput(e)}
                          onBlur={handleBlur}
                          required
                        ></input>
                        <ErrorInfo />
                      </div>
                      <div className={`form-group col-md-4 col-sm-12 my-2 ${errors.zip ? 'invalid' : ''}`}>
                        <label className="required" htmlFor="zip">
                          Zip Code
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-lg"
                          onChange={e => updateInput(e)}
                          name="zip"
                          onKeyPress={handleKeyPress}
                          id="zip"
                          onBlur={handleBlur}
                          required
                          onWheel={e => e.target.blur()}
                          onKeyDown={e => {
                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') return e.preventDefault()
                          }}
                        ></input>
                        <ErrorInfo />
                      </div>

                      {isIndividual && (
                        <>
                          <Box className="col-sm-12 my-2">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  size="large"
                                  sx={{
                                    color: '#BDBDCE',
                                    '&.Mui-checked': {
                                      color: '#0A78CD',
                                    },
                                  }}
                                  onChange={e => {
                                    const { checked } = e.target
                                    if (checked) {
                                      SSNNumber.current.value = ''
                                      updateForm({ ...formDetails, isUSCitizen: !checked, social_security_number: '' })
                                    } else {
                                      updateForm({
                                        ...formDetails,
                                        isUSCitizen: !checked,
                                        nonUSIDNo: '',
                                        issuanceCountry: '',
                                      })
                                      updateError({ ...errors, issuanceCountry: false, nonUSIDNo: false })
                                    }
                                    setRequiredFields({
                                      ...requiredFields,
                                      ssnField: !requiredFields.ssnField,
                                    })
                                  }}
                                  defaultChecked={false}
                                />
                              }
                              label={
                                <Box color="#66668F" fontSize="12px">
                                  I am not a US citizen / permanent resident
                                </Box>
                              }
                            />
                          </Box>
                          <div className="form-group col-md-8 col-sm-12 my-2">
                            <label className={`${!requiredFields.ssnField ? 'required' : ''}`} htmlFor="SSNNumber">
                              Social Security Number
                            </label>
                            <p className="SSNBox">
                              <input
                                onFocus={() => {
                                  SSNNumber.current.className = 'd-none form-control form-control-lg'
                                  maskedTextBox.current.className = 'd-block form-control form-control-lg'
                                  maskedTextBox.current.focus()
                                }}
                                required={!requiredFields.ssnField}
                                className="form-control form-control-lg"
                                placeholder="xxx-xx-xxxx"
                                id="SSNNumber"
                                ref={SSNNumber}
                                type="text"
                                disabled={requiredFields.ssnField}
                              />
                              <input
                                id="SSNValue"
                                ref={maskedTextBox}
                                onKeyDown={e => maskSSN(e, true)}
                                onKeyUp={e => maskSSN(e, true)}
                                onMouseDown={e => maskSSN(e, true)}
                                onMouseUp={e => maskSSN(e, true)}
                                onFocus={e => maskSSN(e, true)}
                                onBlur={e => {
                                  maskSSN(e, false)
                                  maskedTextBox.current.className = 'd-none form-control form-control-lg'
                                  SSNNumber.current.className = 'd-block form-control form-control-lg'
                                }}
                                maxLength={9}
                                name="social_security_number"
                                type="text"
                                onKeyPress={handleKeyPress}
                                placeholder="xxx-xx-xxxx"
                                className="d-none"
                                pattern={!requiredFields.ssnField ? '.{9}' : '*'}
                                title="Ensure this field has at least 9 characters."
                                required={!requiredFields.ssnField}
                              />
                            </p>
                          </div>
                          <div className={`form-group col-md-8 col-sm-12 my-2 ${errors.nonUSIDNo ? 'invalid' : ''}`}>
                            <label className={`${requiredFields.ssnField ? 'required' : ''}`} htmlFor="nonUS">
                              Non-US Persons (SSN, Passport No., or similar identifier)​
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-lg"
                              onChange={e => updateInput(e)}
                              name="nonUSIDNo"
                              id="nonUS"
                              disabled={!requiredFields.ssnField}
                              required
                              onBlur={handleBlur}
                            ></input>
                            <ErrorInfo />
                          </div>
                          <div
                            className={`form-group col-md-4 col-sm-12 my-2 ${errors.issuanceCountry ? 'invalid' : ''}`}
                          >
                            <label
                              className={`${requiredFields.ssnField ? 'required' : ''}`}
                              htmlFor="issuranceCountry"
                            >
                              Country of Issuance
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-lg"
                              onChange={e => updateInput(e)}
                              name="issuanceCountry"
                              id="issuranceCountry"
                              disabled={!requiredFields.ssnField}
                              required={requiredFields.ssnField}
                              onBlur={handleBlur}
                            ></input>
                            <ErrorInfo />
                          </div>
                        </>
                      )}

                      {!isIndividual && (
                        <Box className="row">
                          <Box
                            className="col-sm-12 mt-5 mb-4 pt-2"
                            color="#0A78CD"
                            fontWeight={600}
                            fontSize="12px"
                            borderTop="solid 1px #ede6e6"
                          >
                            AUTHORIZED REPRESENTATIVE
                          </Box>

                          <div
                            className={`form-group col-md-4 col-sm-12 my-2 ${errors.authRepFirstName ? 'invalid' : ''}`}
                          >
                            <label className="required" htmlFor="authRepFirstName">
                              First Name
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-lg"
                              onChange={e => updateInput(e)}
                              name="authRepFirstName"
                              id="authRepFirstName"
                              required
                              onBlur={handleBlur}
                            ></input>
                            <ErrorInfo />
                          </div>
                          <div
                            className={`form-group col-md-4 col-sm-12 my-2 ${errors.authRepLastName ? 'invalid' : ''}`}
                          >
                            <label className="required" htmlFor="authRepLastName">
                              Last Name
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-lg"
                              onChange={e => updateInput(e)}
                              name="authRepLastName"
                              id="authRepLastName"
                              required
                              onBlur={handleBlur}
                            ></input>
                            <ErrorInfo />
                          </div>
                          <div className={`form-group col-md-4 col-sm-12 my-2 ${errors.authRepTitle ? 'invalid' : ''}`}>
                            <label className="required" htmlFor="title">
                              Your Title
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-lg"
                              onChange={e => updateInput(e)}
                              name="authRepTitle"
                              id="title"
                              required
                              onBlur={handleBlur}
                            ></input>
                            <ErrorInfo />
                          </div>
                        </Box>
                      )}

                      <div className="formAction mt-5">
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="large"
                              sx={{
                                color: '#BDBDCE',
                                '&.Mui-checked': {
                                  '& .MuiSvgIcon-root': { borderRadius: '10px' },
                                  color: '#0A78CD',
                                },
                              }}
                              onChange={e => {
                                const { checked } = e.target
                                updateForm({ ...formDetails, acceptanceStatus: checked })
                                updateTermsStatus(!isTermsAgreed)
                              }}
                              defaultChecked={isTermsAgreed}
                            />
                          }
                          sx={{ alignItems: 'start' }}
                          label={
                            <span style={{ fontSize: '12px', color: '#66668F' }}>
                              By clicking Submit, I acknowledge I have read, understand, and agree to the Markaaz{' '}
                              <Link
                                underline="hover"
                                sx={{ cursor: 'pointer', textDecorationColor: '#0A78CD !important' }}
                                target="_blank"
                                href="https://markaaz.com/terms-and-conditions/?_gl=1*3q3j49*_ga*MTM4NDc3ODI0OC4xNjQ5NDc2OTU1*_ga_ERS8LY82HR*MTY1MDQzNTgwNi4yNC4xLjE2NTA0MzU4MzIuMzQ."
                                rel="noreferrer"
                              >
                                <Typography component="span" variant="button3" color="#0A78CD">
                                  {' Terms and Conditions'}
                                </Typography>
                              </Link>
                              , including the arbitration, limitation of liability, and classname waiver provisions. I
                              also acknowledge I have read and understand the Markaaz{' '}
                              <Link
                                underline="hover"
                                sx={{ cursor: 'pointer', textDecorationColor: '#0A78CD !important' }}
                                target="_blank"
                                href="https://markaaz.com/privacy/"
                                rel="noreferrer"
                              >
                                <Typography component="span" variant="button3" color="#0A78CD">
                                  {' Privacy Policy'}
                                </Typography>
                              </Link>
                              .
                            </span>
                          }
                        />
                        {showError && (
                          <Box
                            color="#D14343"
                            paddingY="13px"
                            paddingX="20px"
                            sx={{ background: '#FDF6F6', border: '1px solid #D14343', width: '100%' }}
                            borderRadius="8px"
                            width="300px"
                            textAlign="center"
                            fontSize="14px"
                          >
                            Beneficiary Owner already created.
                          </Box>
                        )}
                        <Button
                          submit
                          loading={loading}
                          type={isTermsAgreed && validDetails ? PRIMARY_BUTTON : DISABLED_BUTTON}
                          disabled={!isTermsAgreed}
                          sx={{ width: '200px' }}
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </form>
                </Box>
              </>
            ) : (
              <Box display="flex" justifyContent="center">
                <Loader type="converging-spinner" />
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
  )
}

export default BeneficialForm
